<template>
  <div class="canlender-box" v-clickoutside="closeDetail" @mousemove="checkDom">
    <full-calendar ref="calendar" :events="events" :config="calendarConf" @event-created="createEvent"
      @event-render="eventRender" @event-selected="goDetail" @day-click="closeDetail" @view-render="viewChange"
      @getView="getView"></full-calendar>
    <div class="calender-pop" v-if="isDetail" :style="{ top: detailPos.y + 'px', left: detailPos.x + 'px' }"
      @mouseenter="showIt" @mouseleave="hiddenIt">
      <!-- v-if="isDetail" -->
      <!-- <div v-if="dataType === 'meeting'" class="detail-container">
        <div class="detail-time">
          <p>
            {{detailStart}}
           </p>
          至
          <p>
            {{detailEnd}}
          </p>
        </div>
        <div class="detail-creator">
          <h3>会议发起人</h3>
          <div>
            <Avatar :icon="'person'" :src="detailCreator[0].headPic">{{detailCreator[0].name}}</Avatar>
            <p>{{detailCreator[0].name}}</p>
          </div>
        </div>
        <div class="detail-title">
          <h3>{{detailTitle}}</h3>
          {{detailRoom}}
        </div>
        <div class="detail-agenda">
          <pre>{{detailAgenda}}</pre>
        </div>
      </div> -->
      <div class="new-detail-meeting" :class="{
          'fixed-weight': dataType === '待办事项',
        }">
        <div class="top">
          <Avatar :icon="userInfo.englishName ? '' : 'person'" :src="userInfo.headPic" style="text-aline: center"
            slot="prefix" size="small">{{
              userInfo.englishName ? userInfo.englishName.substr(0, 2) : ""
            }}</Avatar>
          <span class="user-name">{{ userInfo.englishName }}</span>
          <span class="today">{{ event.month }}/{{ event.day }}</span>
        </div>
        <!-- <div class="work-time">
          <span v-if="event.workStartTime">上班：{{ event.workStartTime }}</span>
          <span v-if="event.workEndTime">下班：{{ event.workEndTime }}</span>
        </div> -->
        <div class="one-meeting" v-if="dataType === 'meeting' || dataType === 'outing'">
          <div :class="{
              'end-it': event.status == '已结束',
              'start-it': event.status != '已结束',
            }">
            <div class="meeting-title">
              <span v-if="event.firstName.length<25"> {{ event.firstName }}</span>
              <span v-else>
                <el-tooltip class="item" effect="light" :content="event.firstName" placement="top-start">
                  <span>{{ event.firstName.slice(0,25) }}...
                  </span>
                </el-tooltip>
              </span>
            </div>
          </div>
          <div class="meeting-detail">
            <span class="time"> {{ event.eventTime }} </span>
            <span class="vertical-bar">|</span>
            <span class="add" v-if="event.roomName">
              <span v-if="event.roomName.length<10"> {{ event.roomName }}</span>
              <span v-else>
                <el-tooltip class="item" effect="light" :content="event.roomName" placement="top-start">
                  <span>{{ event.roomName.slice(0,10) }}...
                  </span>
                </el-tooltip>
              </span>

            </span>
            <span class="vertical-bar">|</span>
            <div v-for="(item, index) in event.allUserItems" class="mini-headpic">
              <Avatar class="avatar" v-if="index < 5" :src="item.headPic" :icon="item.name ? '' : 'person'">
                {{ item.name ? item.name.substr(0, 2) : "" }}</Avatar>
            </div>
            <Avatar style="color: #f56a00; background-color: #fde3cf" v-if="event.allUserItems.length > 4">
              +{{ event.allUserItems.length - 5 }}</Avatar>
          </div>
          <div class="meeting-status">
            <div :class="{
                'end-it': event.status == '已结束',
                'start-it': event.status != '已结束',
              }">
              {{ event.status }}
            </div>
            <span class="go-detail" v-if="showAllBtn">
              <el-button type="primary" round size="mini" @click="goDetail()">详情</el-button>
            </span>
          </div>
        </div>
        <div v-if="dataType === '待办事项'" v-loading="showWatingWork" style="height: 220px">
          <template v-if="number != 0 && showWatingWork == false">
            <div v-for="(item, index) in todoList">
              <template v-if="item.number != 0">
                <div class="one-meeting apply-all" v-for="(i, k) in item.list" :key="k">
                  <div class="meeting-title">
                    {{ i.creatorEnName }} 创建了

                    <el-tooltip class="item" effect="light" :content="i.name" placement="left">
                      <!-- <el-button>{{i.name}} </el-button>    -->
                      <span class="small-title">{{i.name}}</span>
                    </el-tooltip>
                    <!-- {{ i.name }} -->
                  </div>
                  <div class="meeting-status">
                    <div class="start-it">{{ i.stateNameMe }}</div>
                    <span class="go-detail" v-if="showAllBtn">
                      <el-button type="primary" round size="mini" @click="jump(i)">详情</el-button>
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="no-tips">
              <img src="../assets/images/dri/noResult.png" alt="" />
              <p>{{ noWatingMsg }}</p>
            </div>
          </template>
        </div>
        <div v-else-if="dataType === 'vacation'">
          <div class="one-meeting">
            <div class="meeting-title">{{ event.title }}</div>

            <div class="meeting-detail">
              {{ event.start }} 至 {{ event.end }}
            </div>
            <div v-if="event.dayCountE2">{{ event.dayCountE2 }}天</div>
          </div>

          <!-- <div class="detail-creator">
            <h3>请假类型</h3>
            <div>
              <p>{{ detailTitle }}</p>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div v-if="dataType === 'outing'" class="detail-container">
        <div class="detail-time">
          <p>
            {{ detailStart }}
          </p>
          至
          <p>
            {{ detailEnd }}
          </p>
        </div>
        <div class="detail-creator">
          <h3>外出类型</h3>
          <div>
            <p>{{ outingTypeName }}</p>
          </div>
        </div>
        <div v-if="operationArr && operationArr.length" class="detail-creator">
          <h3>同行人员</h3>
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="(i, k) in operationArr"
              :key="k"
              style="margin-left: 5px; margin-top: 5px"
            >
              <Avatar :icon="'person'" :src="i.headPic">{{
                i.englishName
              }}</Avatar>
              <p>{{ i.englishName }}</p>
            </div>
          </div>
        </div>
        <div v-else class="detail-creator">
          <h3>同行人员</h3>
          <div>无</div>
        </div>
        <div style="margin: 10px">
          <h3>外出项目</h3>
          <div style="margin-top: 5px">
            <p>{{ customerName }}</p>
            <p>{{ projectName }}</p>
          </div>
        </div>
      </div>-->
    </div>
    <Modal v-model="isModal" class-name="agenda-modal" ok-text="完成" cancel-text="取消" width="480px" @on-cancel="cancel"
      @on-ok="submitpersonalAgenda">
      <h3>
        设置个人日程
        <span>
          <router-link to="/new/schedule/add">转到会议邀请 >></router-link>
        </span>
      </h3>

      <ul>
        <li class="g-mb-16">
          <i-input type="text" autofocus size="large" v-model="personalAgenda.name" class="ipt" placeholder="输入日程标题">
          </i-input>
        </li>
        <li class="g-mb-16">
          <i-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" size="large" v-model="personalAgenda.agenda"
            class="ipt" placeholder="输入日程内容"></i-input>
        </li>
      </ul>
      <!--<div slot="footer" class="custom-footer">-->
      <!--<Button type="primary" size="large" class="ok" @click="submitReset">完成</Button>-->
      <!--</div>-->
    </Modal>
  </div>
</template>

<script>
  import {
    FullCalendar
  } from "vue-full-calendar";
  import "fullcalendar/dist/locale/zh-cn";
  import 'fullcalendar/dist/fullcalendar.css'


  // import '@fullcalendar/core/vdom' // solves problem with Vite
  // import FullCalendar from '@fullcalendar/vue'
  // import dayGridPlugin from '@fullcalendar/daygrid'
  // import interactionPlugin from '@fullcalendar/interaction'

  import clickoutside from "../directives/clickoutside";
  import TransferDom from "../directives/transfer-dom";
  import CommonMemberIi from "./CommonMemberii";
  import {
    ScheduleAll
  } from "../API/api";
  import Loading from "./popup/Loading";
  import {
    dateToYMD
  } from "../util/util";
  export default {
    name: "calender",
    directives: {
      clickoutside,
      TransferDom
    },
    components: {
      CommonMemberIi,
      FullCalendar,
      Loading,
    },
    watch: {
      goToDate: {
        handler(data) {
          if (data) {
            this.$refs.calendar.fireMethod("gotoDate", data);
          }
        },
      },
    },
    props: {
      userInfo: {
        type: Object,
        default: [],
      },
      events: {
        type: Array,
        default: [],
      },
      showAllBtn: {
        type: Boolean,
      },
      goToDate: {},
      // defaultDate: {}
      calendarConf: {
        type: Object,
        default: function () {
          const _self = this;
          return {
            //    plugins: [ dayGridPlugin, interactionPlugin ],
            // initialView: 'dayGridMonth',
            locale: 'zh-cn',
            // contentHeight: "auto",
            // nowIndicator: true,
            slotLabelFormat: "HH:mm",
            //  plugins: [  interactionPlugin ],
            initialView: 'dayGridMonth',
            allDaySlot: false, //allday 整天的日程是否显示
            slotLabelFormat: "HH:mm", //确定将在议程视图的垂直轴上显示的时间文本。
            slotDuration: "00:30:00", //在agenda的视图中, 两个时间之间的间隔(分钟)
            scrollTime: "08:30:00", //当切换到agenda时，初始滚动条滚动到的时间位置，默认在6点钟的位置
            minTime: "00:00:00", //设置显示的时间从几点开始
            defaultEventMinutes: 30, //默认事件长度
            defaultTimedEventDuration: "00:25:00",
            slotEventOverlap: false, //相同时间段的多个日程视觉上是否允许重叠，默认true允许
            // maxTime: "23:00:00", //设置显示的时间从几点结束
            // defaultView: 'agendaDay',
            defaultView: "agendaDay",
            eventLimit: true,
            dragScroll: false, //不知道干啥呢
            eventLimitClick: "agendaDay",
            //  height:"",//	设置日历的高度，包括header日历头部，默认未设置，高度根据aspectRatio值自适应
            // aspectRatio: 1.5,
            selectable: true,
            editable: false,
            eventStartEditable: false,
            eventDurationEditable: false,
            showNonCurrentDates: true,
            event: {},
            //           businessHours: {
            //   // days of week. an array of zero-based day of week integers (0=Sunday)
            //   daysOfWeek: [ 1, 2, 3, 4 ,5], // Monday - Thursday

            //   startTime: '10:00', // a start time (10am in this example)
            //   endTime: '18:00', // an end time (6pm in this example)
            // },
            // weekMode: "fixed",
            // weekNumbers:"true",
            // allDaySlot: false,
            buttonText: {
              today: '今天',
              month: '月',
              week: '周',
              day: '日'
            },
            header: {
              left: "",
              // center: 'title',
              center: "",
              right: "agendaDay,agendaWeek,month,prev,today,next",
            },
            eventMouseover(ev, jq, view) {
              if (ev.dataType != "考勤") {
                _self.eventDetail(ev, jq, "show");
              }
            },
            eventMouseout(ev, jq, view) {
              setTimeout(function () {
                if (!_self.onItDetail) {
                  _self.eventDetail(ev, jq, "hide");
                }
                // _self.eventDetail(ev, jq, "hide");
              }, 1000);
            },
            eventMouseEnter(info) {},
            viewDisplay(view) {},
            eventAfterAllRender: function (view) {

              if (_self.viewName == "month" && document.getElementsByClassName("fc-today")[1]) {
                document.getElementsByClassName("fc-today")[1].innerHTML =
                  "<div>Today</div>";
              }
              // 　　　　return actualTop;
            }, //当所有Event对象渲染完成时触发
            dayClick(date, jsEvent, view) {
              // _self.dayClick(date);
              //自行定义事件
            },
            getDate() {},
            dayMouseover() {},
          };
        },
      },
    },
    data() {
      return {
        personalAgenda: {
          name: "",
          agenda: "",
          startTime: null,
          endTime: null,
        },
        isLoading: false,
        isModal: false,
        detailRoom: null,
        detailTitle: null,
        detailAgenda: null,
        detailStart: null,
        detailEnd: null,
        detailId: null,
        isDetail: false,
        onItDetail: false,
        detailCreator: [],
        detailPos: {
          x: null,
          y: null,
        },
        dataType: "",
        outingTypeName: "",
        operationArr: [],
        customerName: "",
        projectName: "",
        viewName: "",
        //待执行
        taskWaitingList: [],
        taskWaitingNumber: null,
        projectReviewList: [],
        projectReviewNumber: null,
        hetongReviewList: [],
        hetongReviewNumber: null,
        taskList: [],
        taskNumber: null,
        taskBaoxiaoList: [],
        taskBaoxiaoNumber: null,
        taskWaichuList: [],
        taskWaichuNumber: null,
        vacationList: [],
        vacationNumber: null,
        equipmentList: [],
        equipmentNumber: null,
        customerList: [],
        customerNumber: null,
        supplyList: [],
        supplyNumber: null,
        number: 0,
        showWatingWork: true,
        noWatingMsg: "",
        todoList: [],
        userInfoId:JSON.parse(localStorage.getItem("userInfo")).id
      };
    },
    mounted() {

    },
    created() {
      this.initAllTask();
    },
    methods: {
      getInitToday() {
        if (document.getElementsByClassName("fc-today")[1]&&this.number!=0) {
          let today = document.getElementsByClassName("fc-today")[1];
          //.innerHTML='today'
          let actualLeft = today.offsetLeft;
          let current = today.offsetParent;
          let actualTop = today.offsetTop;
          let elementScrollLeft;
          let elementScrollTop;
          while (current !== null) {
            actualLeft += current.offsetLeft;
            actualTop += current.offsetTop;

            current = current.offsetParent;
          }
          if (document.compatMode == "BackCompat") {
            elementScrollLeft = document.body.scrollLeft;
            elementScrollTop = document.body.scrollTop;
          } else {
            elementScrollLeft = document.documentElement.scrollLeft;
            elementScrollTop = document.documentElement.scrollTop;
          }
          let arr = this.events.filter((item) => {
            return item.dataType == "待办事项";
          });
          let event = arr[0];
          let jqEvent = {
            clientX: actualLeft - elementScrollLeft + 60,
            clientY: actualTop - elementScrollTop + 40,
          };
          this.eventDetail(event, jqEvent, "first");
        }

      },
      hiddenIt() {
        // let that=this
        let that = this;
        setTimeout(function () {
          if (that.isDetail) {
            that.isDetail = false;
            that.onItDetail = false;
          }
        }, 1000);
      },
      showIt() {
        this.onItDetail = true;
      },
      checkDom() {},
      getView() {},
      viewChange(view, ele, $el) {
        this.viewName = view.name;

        this.isDetail = false;
        this.$emit(
          "view-change",
          view.name,
          view.calendar.currentDate.format("YYYY/MM/DD"),
          view.title
        );
        // this.$emit("number",this.number)
      },
      eventRender(event, $el) {},
      submitpersonalAgenda() {
        let eventData = {
          title: this.personalAgenda.name,
          start: this.personalAgenda.startTime,
          end: this.personalAgenda.endTime,
          agenda: this.personalAgenda.agenda,
        };

        this.$refs.calendar.fireMethod("renderEvent", eventData, true);
        this.$emit("on-add", this.personalAgenda);
        this.personalAgenda.agenda = "";
        this.personalAgenda.name = "";
        this.$refs.calendar.fireMethod("unselect");
      },
      cancel() {
        this.isModal = false;
        this.personalAgenda.agenda = "";
        this.personalAgenda.name = "";
        this.$refs.calendar.fireMethod("unselect");
      },
      createEvent(event) {
        this.isModal = true;
        // this.personalAgenda.startTime = event.start.format("YYYY-MM-DD HH:mm");
        // this.personalAgenda.endTime = event.end.format("YYYY-MM-DD HH:mm");
      },

      //获取任务待执行
      jump(item) {
        const {
          customerId,
          projectId,
          workType,
          taskId,
          dataVersion,
          toolkitId,
          productId,
          supplyId,
        } = item;
        switch (workType) {
          case "task":
          case "hetong":
            /* 乱七八糟的规则，反正就是这样的 */
            if (dataVersion === 0 && (toolkitId === 19 || toolkitId === 20)) {
              window.open(`/tasks/list/${customerId}/${projectId}?id=${taskId}&toolkitId=${0}`);
              // this.$router.push(
              //   `/tasks/list/${customerId}/${projectId}?id=${taskId}&toolkitId=${0}`
              // );
            } else {
              window.open(`/tasks/list/${customerId}/${projectId}?id=${taskId}&toolkitId=${productId}`);

              // this.$router.push(
              //   `/tasks/list/${customerId}/${projectId}?id=${taskId}&toolkitId=${productId}`
              // );
            }

            break;
          case "project":
            window.open(`/projects/list/${customerId}?id=${projectId}`)
            // this.$router.push(`/projects/list/${customerId}?id=${projectId}`);
            break;
          case "taskBaoxiao":
            window.open("/myReimburse/list")
            // this.$router.push("/myReimburse/list");
            break;
          case "taskWaichu":
            if (item.dataVersion == "2021") {
              const {
                href
              } = this.$router.resolve({
                path: `/new/schedule/detail/${item.code}`,
                query: {
                  id: item.code
                }
              })
              window.open(href, '_blank');
            } else if (item.dataVersion == "2020") {
              // this.$router.push("/vacation/out");
              window.open("/vacation/out")

            }
            //新页面

            // this.$router.push("/vacation/out");
            break;
          case "vacation":
            window.open("/vacation/audit")
            // this.$router.push("/vacation/audit");
            break;
          case "equipment":
            window.open("/myDevice/apply")
            // this.$router.push("/myDevice/apply");
            break;
          case "customer":
            //品牌
            //         const {href} = this.$router.resolve({
            //   path: `/new/schedule/detail/${i.id}`,
            //   query: {
            //     id: i.id
            //   }
            // })
            // window.open(href, '_blank');
            ///v2/resource/brand/134
            const hrefBrand = this.$router.resolve({
              path: `/v2/resource/brand/${item.customerId}`,
              params: {
                id: String(item.customerId),
              },
            })
            window.open(hrefBrand.href, '_blank');
            // this.$router.push({
            //   name: "brandHome",
            //   params: {
            //     id: String(customerId),
            //   },
            // });
            break;
          case "supply":
            //供应商
            const hrefsupplier = this.$router.resolve({
              path: `/v2/resource/supplier/${item.supplyId}`,
              params: {
                id: String(item.supplyId),
              },
            })
            window.open(hrefsupplier.href, '_blank');
            // this.$router.push({
            //   name: "supplierHome",
            //   params: {
            //     id: String(supplyId),
            //   },
            // });
            break;
          default:
            break;
        }
      },
      //鼠标悬浮上去
      eventDetail(event, jqEvent, status) {
        switch (status) {
          case "show":
            if (event != "") {
              this.detailPos = {
                x: jqEvent.clientX + 10 || jqEvent.pageX + 10,
                y: jqEvent.clientY || jqEvent.pageY,
              };
              this.isDetail = true;
              // this.onItDetail = true;
              let start = event.start.format("YYYY-MM-DD HH:mm");
              let end = event.end.format("YYYY-MM-DD HH:mm");
              this.event = event;
              this.event.month =
                Number(start.slice(5, 6)) === 0 ?
                start.slice(6, 7) :
                start.slice(5, 7);
              if (Number(start.slice(8, 9)) === 0) {
                this.event.day = start.slice(9, 10);
              } else {
                this.event.day = start.slice(8, 10);
              }
              if (event.dataType === "meeting" || event.dataType === "outing") {
                for (let i of this.event.allUserItems) {
                  if (i.englishName) {
                    i.name = i.englishName;
                    // i.status=i.stateName
                  }
                }
                let startMon = start
                  .slice(5, 10).replace("-", "/")
                //.replace(/0/, "");
                let startMonthM = startMon.slice(0, 2) < 10 ? startMon.slice(1, 2) : startMon.slice(0, 2);
                let startMonthD = startMon.slice(3, 5) < 10 ? startMon.slice(4, 5) : startMon.slice(3, 5);
                let endMon = end.slice(5, 10).replace("-", "/");
                let endMonthM = endMon.slice(0, 2) < 10 ? endMon.slice(1, 2) : endMon.slice(0, 2);
                let endMonthD = endMon.slice(3, 5) < 10 ? endMon.slice(4, 5) : endMon.slice(3, 5);
                if (start.slice(0, 10) == end.slice(0, 10)) {
                  this.event.eventTime =
                    startMonthM + '/' + startMonthD + start.slice(10, 16) + "-" + end.slice(11, 16);
                } else {
                  this.event.eventTime =
                    startMonthM + '/' + startMonthD +
                    start.slice(10, 16) +
                    "-" +
                    endMonthM + '/' + endMonthD +
                    end.slice(10, 16);
                }
              } else if (event.dataType === "待办事项") {} else if (event.dataType === "vacation") {
                this.event.start = start;
                this.event.end = end;
              }

              this.dataType = event.dataType;
            }
            break;
          case "hide":
            this.closeDetail();
            break;
          case "first":
            //第一次进来
            this.detailPos = {
              x: jqEvent.clientX + 10 || jqEvent.pageX + 10,
              y: jqEvent.clientY || jqEvent.pageY,
            };

            this.isDetail = true;
            this.event = event;
            this.dataType = event.dataType;

            this.event.month =
              Number(this.event.start.slice(5, 6)) === 0 ?
              this.event.start.slice(6, 7) :
              this.event.start.slice(5, 7);
            if (Number(this.event.start.slice(8, 9)) === 0) {
              this.event.day = this.event.start.slice(9, 10);
            } else {
              this.event.day = this.event.start.slice(8, 10);
            }
            break;
        }
      },
      eventSelected(event) {
        //鼠标点击跳转
        // this.$router.push(`/schedule/meeting/${event.scheduleId}`);
      },
      closeDetail() {
        // setTimeout(function(){
        this.isDetail = false;

        // },1000)
      },
      goDetail() {
        console.log(this.event,'eventy--------')
        let allUserId = Object.values(this.event.allUserId);
			allUserId = allUserId.map(Number);
			let allIds = [...allUserId, this.event.auditorId,this.event.creatorId];
      console.log(allIds,'allIds----',this.userInfoId,'-----')
			let id = this.event.id || this.event.outingId;
			if (allIds.indexOf(this.userInfoId) > -1) {
			if (this.event.dataType == "meeting" || this.event.dataType == "outing") {
          this.$router.push({
            path: `/new/schedule/detail/${this.event.id}`,
            query: {
              id: this.event.id,
            },
          });
        }
			} else {
				this.$message.error('您没有权限查看该员工会议信息');
			}
        // this.isLoading = true;
        
      },
      async getWorkNumberTask() {
        let params = {
          typeId: 3,
        };
        const taskWaiting = await this.getallSame(params);
        this.taskWaitingList = taskWaiting.data.retData.workList;
        this.taskWaitingNumber = taskWaiting.data.retData.workNumber;
      },
      async initAllTask() {
        await Promise.all([
          //供应商_审批
          (async () => {
            await this.getWorkNumberTask();
          })(),
          (async () => {
            await this.getWorkNumberProject();
          })(),
          (async () => {
            await this.getWorkNumberContract();
          })(),
          (async () => {
            await this.getTaskApproval();
          })(),
          (async () => {
            await this.getTravelExpense();
          })(),
          (async () => {
            await this.getOutApply();
          })(),
          (async () => {
            await this.getLeave();
          })(),
          (async () => {
            await this.getEquipmentApply();
          })(),
          (async () => {
            await this.getBrandApply();
          })(),
          (async () => {
            await this.getSupplierApply();
          })(),
        ]);
let list=[...this.supplyList,...this.customerList,...this.equipmentList,...this.vacationList,...this.taskWaichuList,...this.taskBaoxiaoList,...this.taskList,...this.hetongReviewList,...this.projectReviewList,...this.taskWaitingList];
 //时间排序
 list.sort(function (a, b) {
        let t1 = new Date(Date.parse(a.timeCreate.replace(/-/g, "/")))
        let t2 = new Date(Date.parse(b.timeCreate.replace(/-/g, "/")))
        return   t2.getTime()-t1.getTime()
      })
        this.todoList = [{
            number: this.supplyNumber, //供应商_审批
            list: this.supplyList,
            name: "供应商审批",
          },
          {
            number: this.customerNumber, //品牌_审批
            list: this.customerList,
            name: "品牌审批",
          },
          {
            number: this.equipmentNumber, //设备_审批
            list: this.equipmentList,
            name: "设备审批",
          },
          {
            number: this.vacationNumber, //请假_审批
            list: this.vacationList,
            name: "请假审批",
          },
          {
            number: this.taskWaichuNumber, //外出_审批
            list: this.taskWaichuList,
            name: "外出审批",
          },
          {
            number: this.taskBaoxiaoNumber,
            list: this.taskBaoxiaoList, //报销_审批
            name: "报销审批",
          },
          {
            number: this.taskNumber, //任务_审批
            list: this.taskList,
            name: "任务审批",
          },
          {
            number: this.hetongReviewNumber, //合同_审批
            list: this.hetongReviewList,
            name: "合同审批",
          },
          {
            number: this.projectReviewNumber, //项目待执行
            list: this.projectReviewList,
            name: "项目审批",
          },
          {
            number: this.taskWaitingNumber, //任务待执行
            list: this.taskWaitingList,
            name: "任务待执行",
          },
        ];
        this.number =
          this.taskWaitingNumber +
          this.projectReviewNumber +
          this.hetongReviewNumber +
          this.taskNumber +
          this.taskBaoxiaoNumber +
          this.taskWaichuNumber +
          this.vacationNumber +
          this.equipmentNumber +
          this.customerNumber +
          this.supplyNumber;
        this.$emit("number", this.number)
        this.noWatingMsg = this.number == 0 ? "今日暂无待办事项" : "";
        if (this.number != 0 && JSON.parse(localStorage.userInfo).id == this.userInfo.id) {
          this.getInitToday();
        }
        this.showWatingWork = false;
      },
      //项目_审批
      async getWorkNumberProject() {
        let params = {
          typeId: 2,
          workType: "project",
        };
        const projectReview = await this.getallSame(params);
        this.projectReviewList = projectReview.data.retData.workList;
        this.projectReviewNumber = projectReview.data.retData.workNumber;
      },
      //合同_审批
      async getWorkNumberContract() {
        let params = {
          typeId: 2,
          workType: "hetong",
        };
        const hetongReview = await this.getallSame(params);
        this.hetongReviewList = hetongReview.data.retData.workList;
        this.hetongReviewNumber = hetongReview.data.retData.workNumber;
      },
      //任务_审批
      async getTaskApproval() {
        let params = {
          typeId: 2,
          workType: "task",
        };
        const task = await this.getallSame(params);
        this.taskList = task.data.retData.workList;
        this.taskNumber = task.data.retData.workNumber;
      },
      //报销_审批
      async getTravelExpense() {
        let params = {
          typeId: 2,
          workType: "taskBaoxiao",
        };
        const taskBaoxiao = await this.getallSame(params);
        this.taskBaoxiaoList = taskBaoxiao.data.retData.workList;
        this.taskBaoxiaoNumber = taskBaoxiao.data.retData.workNumber;
      },
      //外出_审批
      async getOutApply() {
        let params = {
          typeId: 2,
          workType: "taskWaichu",
        };
        const taskWaichu = await this.getallSame(params);
        this.taskWaichuList = taskWaichu.data.retData.workList;
        this.taskWaichuNumber = taskWaichu.data.retData.workNumber;
      },
      //请假_审批
      async getLeave() {
        let params = {
          typeId: 2,
          workType: "vacation",
        };
        const vacation = await this.getallSame(params);
        this.vacationList = vacation.data.retData.workList;
        this.vacationNumber = vacation.data.retData.workNumber;
      },
      //设备_审批
      async getEquipmentApply() {
        let params = {
          typeId: 2,
          workType: "equipment",
        };
        const equipment = await this.getallSame(params);
        this.equipmentList = equipment.data.retData.workList;
        this.equipmentNumber = equipment.data.retData.workNumber;
      },
      //品牌_审批
      async getBrandApply() {
        let params = {
          typeId: 2,
          workType: "customer",
        };
        const customer = await this.getallSame(params);
        this.customerList = customer.data.retData.workList;
        this.customerNumber = customer.data.retData.workNumber;
      },
      //供应商_审批
      async getSupplierApply() {
        let params = {
          typeId: 2,
          workType: "supply",
        };
        const supply = await this.getallSame(params);
        this.supplyList = supply.data.retData.workList;
        this.supplyNumber = supply.data.retData.workNumber;
      },
      getallSame(params) {
        return this.$http.post(
          ScheduleAll.worknumber,
          this.qs.stringify(params), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token")
            },
          }
        );
      },
    },
  };

</script>

<style scoped lang="less">
  .canlender-box {
    position: relative;

    //   .fixed-weight{
    //     width: 374px !important;
    //     overflow-x:hidden ;
    //     .one-meeting{
    // //  min-height: 107px !important;
    //     }
    //   }
    .new-detail-meeting {
      min-width: 374px;
      max-height: 500px;
      overflow-y: auto;
      // height: 426px;
      background: #ffffff;
      box-shadow: 0px 1px 16px 0px rgba(20, 46, 110, 0.4);
      border-radius: 8px;
      padding: 17px 20px;

      .top {
        position: relative;
        display: flex;
        align-items: center;
        font-size: 16px;
        margin-bottom: 8px;

        .today {
          position: absolute;
          right: 0;
        }

        .user-name {
          margin-left: 8px;
          font-size: 16px;
        }
      }

      .work-time {
        padding: 0 25px;
        color: #868e96;
        font-size: 14px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
      }

      .no-tips {
        img {
          width: 200px;
          margin-bottom: 20px;
        }

        margin-top: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        >p {
          color: 868e96;
        }
      }
    }

    .one-meeting {
      min-width: 334px;
      height: 107px;

      background: #f8f9fa;
      border-radius: 6px;
      padding: 10px 13px 13px 18px;
      // color: black;
      margin: 0 auto;
      font-weight: 500;

      .end-it {
        color: #868e96;
      }

      .start-it {
        color: black;
      }

      .meeting-title {
        font-size: 16px;
        margin-bottom: 10px;
        // width: 300px;

      }

      .meeting-detail {
        font-size: 14px;
        color: #868e96;
        display: flex;
        align-items: center;
        margin-bottom: 14px;

        .mini-headpic {
          /deep/ .ivu-avatar>* {
            line-height: 24px;
          }
        }

        .ivu-avatar {
          width: 24px;
          height: 24px;
          line-height: 24px;
          border-radius: 50%;
        }

        .vertical-bar {
          padding: 0 13px;
        }

        .avatarList {
          display: inline-block;
        }

        .avatar {
          margin-right: -8px;
          border: 1px solid white;
        }
      }

      .meeting-status {
        position: relative;
        display: flex;
        align-item: center;

        .end-it {
          display: inline-block;
          color: #ed0423;
        }

        .start-it {
          display: inline-block;
          color: #2d8ef8;
        }

        .go-detail {
          position: absolute;
          right: 0;
        }

        // button{
        //   width: 57px;
        //   height: 28px;
        // }
      }
    }

    .apply-all {
      margin-bottom: 10px;
      height: 79px;

      .meeting-title {
        width: 300px;
        overflow: hidden;
        /* 强制文字不换行 */
        white-space: nowrap;
        /* 超出部分显示省略号 */
        text-overflow: ellipsis;

      }
    }

    /deep/.fc-button-group {
      margin-bottom: 21px;

      .fc-button {
        border: none;
        // background: #F2F3F7;
        // &:hover{
        //     background-color: #2d8ef8 !important;
        //         border-color: #2d8ef8 !important;
        // }
        //     }
        //     .fc-state-active {
        //         background-color: #2d8ef8 !important;
        //         border-color: #2d8ef8 !important;
      }

      .fc-state-disabled {
        background-color: #f2f3f7 !important;
        color: #666 !important;
        cursor: not-allowed !important;
      }

      :first-child {
        border-radius: 8px 0px 0px 8px !important;
      }

      :nth-child(2) {
        margin: 0 2px;
      }

      :nth-child(3) {
        border-radius: 0 8px 8px 0;
        margin-right: 20px;
      }

      :nth-child(4) {
        width: 28px;
        border-radius: 8px 0px 0px 8px;
        padding: 0;
      }

      :nth-child(6) {
        width: 28px;
        border-radius: 0 8px 8px 0;
        margin-right: 21px;
        text-align: center;
        padding: 0;
      }
    }

    /deep/ .ivu-avatar-small {
      width: 40px !important;
      height: 40px !important;
      line-height: 40px !important;
    }

    /deep/ .ivu-avatar-string {
      position: inherit !important;
      left: 0 !important;
      line-height: 24px;
    }

    /deep/.fc-time-grid-event .fc-time {
      display: none;
    }

    /deep/.fc-unthemed td.fc-sun {
      background: linear-gradient(135deg,
          #ffffff 25%,
          #f3f8ff 0,
          #f3f8ff 50%,
          #ffffff 0,
          #ffffff 75%,
          #f3f8ff 0);
      background-size: 10.6px 10px !important;
      color: #adb5bd;
      overflow: hidden;
    }

    /deep/ .fc-unthemed td.fc-sat {
      background: linear-gradient(135deg,
          #ffffff 25%,
          #f3f8ff 0,
          #f3f8ff 50%,
          #ffffff 0,
          #ffffff 75%,
          #f3f8ff 0);
      background-size: 10.6px 10px !important;
      color: #adb5bd;
      overflow: hidden;
    }

    /deep/ .fc-v-event.fc-not-start {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }

    .fc-time-grid .fc-event,
    .fc-time-grid .fc-bgevent {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }
  }

  .calender-pop {
    position: fixed;
    border: 1px solid #ced4da;
    border-radius: 5px;
    background-color: #fff;
    z-index: 100;
    transform: translate(0, -50%);

    // width: 200px;
    .detail-container {
      min-height: 200px;
      /*max-height: 400px;*/
      /*overflow-y: auto;*/
    }

    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(-50%, -50%) rotate(45deg);
      background-color: #fff;
      border-left: 1px solid #ced4da;
      border-bottom: 1px solid #ced4da;
      border-top: 0 none;
      border-right: 0 none;
      width: 10px;
      height: 10px;
    }

    /*top: ;*/
  }

  .detail-time {
    border-bottom: 1px solid #ced4da;
    padding: 10px;
    font-size: 14px;
  }

  .detail-title {
    border-bottom: 1px solid #ced4da;
    padding: 10px;
  }

  .detail-creator {
    >div {
      display: inline-block;
      text-align: center;
      margin-top: 5px;
    }

    .detail-title;
  }

  .detail-agenda {
    padding: 10px;
    word-wrap: break-word;
    word-break: break-all;

    pre {
      word-wrap: break-word;
      word-break: break-all;
      white-space: pre-wrap;
    }
  }

  .agenda-modal {
    h3 {
      color: #495057;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 24px;

      span {
        font-size: 12px;
        margin-left: 16px;
        font-weight: normal;
      }
    }

    .ipt {
      .ivu-input {
        height: 48px;
      }
    }

    /*.ipt {*/
    /*height: 48px;*/
    /*border-radius: 4px;*/
    /*border: 1px solid #ced4da;*/
    /*font-size: 14px;*/
    /*padding: 0 16px;*/
    /*width: 100%;*/
    /*}*/
    /*.ipt-group {*/
    /*padding: 0;*/
    /*overflow: hidden;*/
    /*display: flex;*/
    /*button {*/
    /*height: 100%;*/
    /*border: 0 none;*/
    /*background-color: #2d8ef8;*/
    /*color: #fff;*/
    /*padding: 0 10px;*/
    /*transition: background-color .5s;*/
    /*&:hover {*/
    /*background-color: lighten(#2d8ef8, 10%);*/
    /*}*/
    /*&:active {*/
    /*background-color: darken(#2d8ef8, 10%);*/
    /*}*/
    /*}*/
    /*input {*/
    /*flex: 1;*/
    /*border: 0 none;*/
    /*height: 100%;*/
    /*padding: 0 16px;*/
    /*}*/
    /*}*/
  }

</style>
<style lang='less'>
  .canlender-box {

    .fc-ltr .fc-popover .fc-header .fc-title,
    .fc-rtl .fc-popover .fc-header .fc-close {
      float: none !important;
    }
  }

  .fc-unthemed td.fc-today {
    background: white;
  }

  .fc-unthemed .fc-agendaWeek-view td.fc-today {
    background: white;
  }

  .fc-time-grid .fc-slats td {
    height: 40px;
  }

  .fc-axis .fc-widget-content {
    width: 83px !important;
  }

  .fc-view-container .fc-view .fc-head .fc-head-container .fc-widget-header.fc-day-header {
    text-align: center;
  }

  .fc-time-grid .fc-event,
  .fc-time-grid .fc-bgevent {
    display: flex;
    align-items: center;
    justify-content: center;
    // margin:  0 auto;
    // text-align: center;
  }

  .fc-header-toolbar {
    // width: 700px;
  }

  .fc-axis .fc-time .fc-widget-content {
    >span {
      background: #ced4da !important;
    }
  }

  .fc-today {
    font-size: 20px;
    font-weight: 400;
    color: #2d8ef8;
    // line-height: 20px;
    margin: 5px 0 0 10px !important;

    >div {
      margin: 5px 0 0 10px;
    }
  }

  .fc-unthemed .fc-month-view td.fc-today {
    background: white;
  }

  .fc-day-grid-event .fc-time {
    display: none;
  }

  .textitle {
    // color: red !important;
    display: flex !important;
    justify-content: start !important;

    .fc-title {
      padding-left: 44px !important;

    }
  }

</style>
